/* eslint-disable no-console */
/* eslint-disable unicorn/prefer-module */
import { useEffect, useState, useMemo } from "react";
import { Loader, Header } from "../../components";
import { useAuthContext } from "../../context/auth";
import { getEdificiosOperativos, getCategorias } from "../../utils";
import styles from "./ListadoVetos.module.scss";

function Vetos() {
  const [edificios, setEdificios] = useState();
  const [categorias, setCategorias] = useState([]);
  const [selectedCategoria, setSelectedCategoria] = useState(""); // Estado para la categoría seleccionada
  const [selectedEdificio, setSelectedEdificio] = useState(""); // Estado para el edificio seleccionado
  const { pais } = useAuthContext();

  useEffect(() => {
    const initialize = async () => {
      const newEdificios = await getEdificiosOperativos({ pais });
      setEdificios(newEdificios);
      const newCategorias = await getCategorias();
      setCategorias(newCategorias);
    };

    initialize();
  }, [pais]);

  // Filtra los edificios según la categoría y el edificio seleccionado
  const filteredEdificios = useMemo(() => {
    if (!edificios || !categorias) return [];
    return [...edificios]
      .filter(({ vetos, edificio }) => {
        // Filtro por categoría
        if (selectedCategoria) {
          const selectedCat = categorias.find((cat) => cat.nombre === selectedCategoria);
          if (!selectedCat) return false;
          if (!vetos) return false; // No vetos, exclude from filter
          if (typeof vetos === "number") {
            return vetos === selectedCat.id;
          } else if (typeof vetos === "string") {
            const vetoIds = vetos
              .split(",")
              .map((id) => parseInt(id.trim(), 10))
              .filter((id) => !isNaN(id));
            return vetoIds.includes(selectedCat.id);
          }
          return false; // Default case for unexpected format
        }
        // Filtro por edificio
        if (selectedEdificio) {
          return edificio.toLowerCase() === selectedEdificio.toLowerCase();
        }
        return true; // Mostrar todos si no hay filtros seleccionados
      })
      .sort((a, b) => a.edificio.localeCompare(b.edificio));
  }, [edificios, selectedCategoria, selectedEdificio, categorias]);

  // Helper function to convert vetos to category names
  const getVetoNames = (vetos) => {
    if (!vetos) return "-";
    if (typeof vetos === "number") {
      const category = categorias.find((cat) => cat.id === vetos);
      return category ? category.nombre : `ID ${vetos} (sin categoría)`;
    } else if (typeof vetos === "string") {
      const vetoIds = vetos
        .split(",")
        .map((id) => parseInt(id.trim(), 10))
        .filter((id) => !isNaN(id));
      return vetoIds
        .map((vetoId) => {
          const category = categorias.find((cat) => cat.id === vetoId);
          return category ? category.nombre : `ID ${vetoId} (sin categoría)`;
        })
        .join(", ");
    }
    return vetos.toString(); // Fallback for unexpected formats
  };

  return (
    <div className={styles.wrapper}>
      <Header>
        <div className={styles.filtros}>
          <select
            id="categoriasDropdown"
            className="form-select form-select-sm"
            value={selectedCategoria}
            onChange={(e) => setSelectedCategoria(e.target.value)}
            style={{ width: 200 }}
          >
            <option value="">Seleccionar Categoría</option>
            {categorias.map((categoria) => (
              <option key={categoria.id} value={categoria.nombre}>
                {categoria.nombre}
              </option>
            ))}
          </select>

          <select
            id="edificiosDropdown"
            className="form-select form-select-sm"
            value={selectedEdificio}
            onChange={(e) => setSelectedEdificio(e.target.value)}
            style={{ width: 200 }}
          >
            <option value="">Seleccionar Edificio</option>
            {[...(edificios || [])]
              .sort((a, b) => a.edificio.localeCompare(b.edificio))
              .map(({ id, edificio }) => (
                <option key={id} value={edificio}>
                  {edificio.toUpperCase()}
                </option>
              ))}
          </select>
        </div>
      </Header>

      <div className={styles.content}>
        {edificios ? (
          <table className="table table-bordered table-striped table-hover table-sm">
            <thead>
              <tr>
                <th style={{ width: "30%" }}>EDIFICIO</th>
                <th style={{ width: "70%" }}>VETO</th>
              </tr>
            </thead>
            <tbody>
              {filteredEdificios.length === 0 ? (
                <tr>
                  <td colSpan="2" className={styles.empty}>
                    No hay vetos en los edificios según los filtros seleccionados :)
                  </td>
                </tr>
              ) : (
                filteredEdificios.map(({ id, edificio, vetos }) => (
                  <tr key={id}>
                    <td>{edificio.toUpperCase()}</td>
                    <td>{vetos ? getVetoNames(vetos) : <span className={styles.sinVeto}>Sin veto</span>}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
}

export default Vetos;
